import React from "react";
import { Link } from "react-router-dom";

export default function UpdateVehicleSpareparts(){
return(

    <div className="updatevehiclespareparts-container my-4">
        <div className="col-md-12">      
              <div className="special-header">
            <div className="page-title">Update Vehicle Spareparts</div>
        </div>
             <form>
                    <div className="row">
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="vehicleno" className="form-label"> Vehicle Number <span className="text-danger">*</span></label>
                            <select id="vehicleno" className="form-control updatevehiclefuel-form-select" >
                                <option>Select</option>
                                <option>New Vehicle</option>
                                <option>MH02WE0002</option>
                                <option>MH02YE0902</option>
                            </select>
                        </div>
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="spareparts" className="form-label">Spareparts <span className="text-danger">*</span>  </label>
                            <input type="text" id="spareparts" className="form-control updatevehiclefuel-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="pdate" className="form-label">Purchase Date<span className="text-danger">*</span> </label>
                            <input type="dare" id="pdate" className="form-control updatevehiclefuel-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="forexdate" className="form-label">Expiry Date <span className="text-danger">*</span></label>
                            <input type="date" id="forexdate" className="form-control updatevehiclefuel-form-control" />
                        </div>

                        
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="quantity" className="form-label"> Quantity <span className="text-danger">*</span></label>
                            <input type="text" id="quantity" className="form-control updatevehiclefuel-form-control" />
                        </div>


                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="amount" className="form-label"> Amount <span className="text-danger">*</span></label>
                            <input type="text" id="amount" className="form-control updatevehiclefuel-form-control" />
                        </div>
                        
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="warranty" className="form-label"> Warranty <span className="text-danger">*</span></label>
                            <input type="text" id="warranty" className="form-control updatevehiclefuel-form-control" />
                        </div>


                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="invoice" className="form-label"> Invoice<span className="text-danger">*</span></label>
                            <input type="file" id="invoice" className="form-control updatevehiclefuel-form-control" />
                        </div>



                        <div className="col-lg-12 col-md-12 mt-3 d-flex justify-content-end">
                            <Link to="/" type="submit" className="btn custom-btn">Update</Link>
                        </div>
                    </div>
                </form>
    </div>
    </div>

);
}

